import { TeacherProfileParams } from '../../../typings';
import { apiConfig } from '../config';
import { postFetch } from '../fetch';

interface Data {
    meId: string | number;
    teacherProfile: TeacherProfileParams;
}

export function patchTeacherProfile(data: Data): Promise<TeacherProfileParams> {
    const { apiPatchTeacherProfile } = apiConfig.getStaticUrls();
    const { meId, teacherProfile } = data;

    return postFetch(`${apiPatchTeacherProfile}${meId}/`, { teacher_profile: teacherProfile });
}
